import React, {forwardRef, useEffect, useLayoutEffect, useState} from 'react'
import ReactDOM from "react-dom"

import {ViewType} from "../../../../core/gd/const/views/view-type"
import {goalsListViews} from "../../../../app/goals/all-goals/top/view-selector/constants"
import NavigationMenuItemUrl from "../../menu-items/menu-item-url"
import {PopoverMenuItemType} from "../../../../core/gd-components/popover-menu/popover-menu/const"

type Props = {
    className?  : string

    noAnimation : boolean
}

export default forwardRef(function MainMenu_MyGoals(props: Props, ref: any) {

    const [animShow, setAnimShow]       = useState(false)
    const [customView, setCustomView]   = useState(gd.session.customViews.getFirstByType(ViewType.MY_GOALS))

    useEffect(()=>{
        const animationDelay = _.delay(()=>{
            setAnimShow(true)
            const dom = ReactDOM.findDOMNode(ref.current)
            gd.utils.Dom.addClass(dom, 'anim-show')
        }, 50)

        return ()=>{
            clearTimeout(animationDelay)
        }
    }, [])

    const onChangeCustomView = () => {
        const newCustomView = gd.session.customViews.getFirstByType(ViewType.MY_GOALS)
        if (newCustomView) setCustomView(newCustomView)
    }

    useLayoutEffect(()=>{
        return gd.bus.subscribeNoContext('gd.session.customViews:change', onChangeCustomView)
    }, [])

    const classes = Classes('menu-my-goals ui5-menu p-t-0', {
        'animation': gd.layout.shouldAnimateMenu && !props.noAnimation,
        'anim-show': animShow
    })

    const title             = customView?.name || 'Goals'
    const navigationSection = customView?.navigationSection

    return (
        <div className={classes} ref={ref}>
            <div className="ui5-app-controls v2 top-header">
                <div className="left txt-truncate">
                    <div className="ui5-title-app-name">{title}</div>
                </div>
            </div>

            <div className="ui5-menu m-t-10">
                <div className="menu-section open m-b-10">
                    {_.map(goalsListViews, (view, key)=> {
                        if (view.type === PopoverMenuItemType.SEPARATOR) return

                        return <NavigationMenuItemUrl key                 = {key}
                                                      icon                = {view.icon!}
                                                      name                = {view.label!}
                                                      navigationSection   = {navigationSection}
                                                      url                 = {'goals/{0}'.f(view.value)}/>
                    })}
                </div>
            </div>
        </div>
    )
})
